import {NgModule} from "@angular/core";
import {BrowserModule} from "@angular/platform-browser";
import {kanServiceModule} from "../services/module";
import {
    MatButtonModule, MatDialogModule, MatIconModule, MatInputModule, MatMenuModule,
    MatSelectModule
} from "@angular/material";
import {kanMails} from "./components/mails/component";
import {TranslateModule} from "@ngx-translate/core";
import {kanMailDialog} from "./dialogs/mail-dialog/component";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {CKEditorModule} from "ng2-ckeditor";
import {kanMailList} from "./components/list/component";
import {kanMailListItem} from "./components/list-item/component";
import {kanCommonModule} from "../common/module";
import {kanMailPreviewDialog} from "./dialogs/mail-preview-dialog/component";
import {kanMailTemplates} from "./components/mail-templates/component";
import {kanMailTemplateDialog} from "./dialogs/mail-template-dialog/component";

@NgModule({
    declarations: [
        kanMails,
        kanMailList,
        kanMailListItem,
        kanMailDialog,
        kanMailPreviewDialog,
        kanMailTemplates,
        kanMailTemplateDialog
    ],
    imports: [
        BrowserModule,
        TranslateModule,
        FormsModule,
        ReactiveFormsModule,
        MatButtonModule,
        MatDialogModule,
        MatInputModule,
        MatIconModule,
        MatMenuModule,
        MatSelectModule,
        CKEditorModule,
        kanServiceModule,
        kanCommonModule
    ],
    entryComponents: [
        kanMailDialog,
        kanMailPreviewDialog,
        kanMailTemplateDialog
    ],
    exports: [
        kanMails,
        kanMailTemplates
    ],
    providers: [],
    bootstrap: []
})
export class kanMailsModule {
}



// WEBPACK FOOTER //
// ./src/modules/mails/module.ts